<!-- @format -->
<template>
    <div>
        <h5 class="mt-4">{{ $t('title') }}</h5>
        <p class="mt-2">{{ $t('description') }}</p>
        <h5 class="my-4">{{ $t('options.title') }}</h5>
        <div class="gst-failed-options-wrapper">
            <div
                class="gst-failed-options u-width-66 pb-md-4"
                :class="$vuetify.breakpoint.mdAndUp ? 'flex-row' : 'flex-column'">
                <div>
                    <h5 class="options-title mb-4">
                        <span class="options-number">1</span>{{ $t('options.replace.title') }}
                    </h5>
                    <p>
                        {{ $t('options.replace.description') }}
                    </p>
                    <BaseImage
                        v-if="!$vuetify.breakpoint.mdAndUp"
                        class="my-3"
                        :src="optionReplaceImage.src"
                        :height="optionReplaceImage.height"
                        :width="optionReplaceImage.width" />
                    <BaseButton
                        :placeholder="$t('options.replace.cta')"
                        color="primary"
                        :depressed="false"
                        @click="onClickReplace" />
                    <p class="note mb-0 pt-4">
                        <BaseIcon
                            width="20"
                            height="20"
                            color="secondary"
                            symbol-id="icons--clock_full"
                            class="gst-icon--clock-outlined u-align-vertical-middle flex-shrink-0 my-auto mr-1 ml-n1" />
                        <span class="gst-font-xss u-align-vertical-middle">{{
                            $t('options.replace.note')
                        }}</span>
                    </p>
                </div>
                <div
                    v-if="$vuetify.breakpoint.mdAndUp"
                    class="image-wrapper">
                    <BaseImage
                        v-if="$vuetify.breakpoint.mdAndUp"
                        :src="optionReplaceImage.src"
                        :height="optionReplaceImage.height"
                        :width="optionReplaceImage.width" />
                </div>
            </div>
            <div class="gst-failed-options u-width-33">
                <h5 class="options-title mb-4">
                    <span class="options-number">2</span>{{ $t('options.refund.title') }}
                </h5>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <p v-html="$t('options.refund.description', { total: bookingTotalPrice })" />
                <BaseButton
                    invert
                    :placeholder="$t('options.refund.cta')"
                    color="primary"
                    @click="onClickRefund" />
            </div>
        </div>
        <p class="gst-font-xss pt-4 mb-0 tertiary--text">
            {{ $t('note') }}
        </p>
        <slot name="payment-summary"></slot>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import currencyFilter from '@core/filters/currencyFull';

export default {
    name: 'BookingContentStatusFailed',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking.theManageBooking.bookingContent.failed',
    },

    computed: {
        ...mapGetters({
            booking: 'booking/get',
            bookingCartId: 'booking/getCartId',
        }),
        computedCartId() {
            return this.bookingCartId || this.$route.params.id;
        },
        orderUuid() {
            return this.booking.uuid;
        },
        optionReplaceImage() {
            return {
                src: require(`@tenant/app/assets/hotel_thumbnail.jpeg`),
                width: '100%',
                height: this.$vuetify.breakpoint.mdAndUp ? '100%' : '80px',
            };
        },
        bookingTotalPrice() {
            return this.booking
                ? currencyFilter(this.booking.totalPrice, this.booking.currency)
                : 0;
        },
    },
    methods: {
        onClickReplace() {
            this.$router.push({
                name: 'booking.replace',
                params: {
                    id: this.computedCartId,
                },
            });
        },
        onClickRefund() {
            this.$router.push({
                name: 'booking.refund.checkout',
                params: { id: this.computedCartId },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import '@scssVariables';
@import '@scssMixins';

// For now there are 2 actions listed to take as options when booking
// is failed. The list of options is numbered and the numbers's
// styling has width/height the value below. Used for styling number
// and for vertical alignment on option title
$option-number-height: 20px;

.gst-booking-failed {
    .gst-failed-options-wrapper {
        display: flex;
        gap: theme-spacing(2);
    }

    .gst-failed-options {
        display: flex;
        padding: theme-spacing(4);
        border: 1px solid theme-color('senary');
        background-color: theme-color('white');
        flex-flow: column;
        gap: theme-spacing(4);

        .options-title {
            height: auto;
            width: 100%;
            min-height: $option-number-height;
        }

        .options-number {
            display: inline-block;
            height: $option-number-height;
            width: $option-number-height;
            line-height: $option-number-height;
            margin-right: theme-spacing(2);
            background-color: theme-color('primary');
            color: theme-color('white');
            font-size: font-size('xs');
            text-align: center;
            vertical-align: text-top;
            border-radius: border-radius('circle');
        }

        .gst-btn {
            height: 45px;
            width: 240px;
            padding: theme-spacing(3, 4);
            font-size: font-size('l');
            font-weight: font-weight('large');
        }

        .gst-icon--clock-outlined {
            font-size: font-size('l');

            ::v-deep path.gst-svg-icon {
                stroke: theme-color('secondary') !important;
                fill: none !important;
            }
        }

        .gst-svg-icon {
            ::v-deep {
                stroke: theme-color('secondary') !important;
                fill: none !important;
            }
        }

        .image-wrapper {
            width: 33%;
        }
    }

    @include mobile-only {
        .gst-failed-options-wrapper {
            flex-direction: column;
        }

        .gst-failed-options,
        .gst-failed-options .gst-btn,
        .gst-failed-options .image-wrapper {
            width: 100%;
        }
    }
}
</style>
